<app-dialog [showHeader]="false" [show]="true"  [minWidth]="430">
    <div class="loading-container">
        <div class="animation">
            <img src="assets/gifs/search.gif"/>
        </div>
        <div class="text">
            <ng-content></ng-content>
        </div>
    </div>
</app-dialog>